'use client';

import { useEffect, useState } from 'react';
import { type NodeProps } from '@xyflow/react';
import { NodeShell } from '../BaseNode';
import { usePipelineStore } from '@/lib/pipeline/store';
import { api } from '@/lib/api';
import { Series } from '@/lib/types';

export default function SaveToGalleryNode({ id, data }: NodeProps) {
  const update = usePipelineStore((s) => s.updateNodeData);
  const rt = usePipelineStore((s) => s.runtime[id]);
  const out = rt?.output as { image?: string; filename?: string } | undefined;
  const d = data as { series_id?: number | null };

  const [series, setSeries] = useState<Series[]>([]);
  useEffect(() => {
    api.getSeries().then(setSeries).catch(() => {});
  }, []);

  return (
    <NodeShell id={id} type="saveToGallery">
      <label className="text-[11px] text-[var(--text-muted)] block">
        Series
        <select
          className="input nodrag w-full text-xs mt-0.5"
          value={d.series_id ?? ''}
          onChange={(e) => update(id, { series_id: e.target.value ? Number(e.target.value) : null })}
        >
          <option value="">No series</option>
          {series.map((s) => (
            <option key={s.id} value={s.id}>
              {s.name}
            </option>
          ))}
        </select>
      </label>

      {out?.image ? (
        // eslint-disable-next-line @next/next/no-img-element
        <img src={out.image} alt="saved" className="rounded-lg w-full mt-1" />
      ) : (
        <div className="text-xs text-[var(--text-muted)] py-6 text-center">
          Connect an image, then Run to save it to the gallery
        </div>
      )}
      {out?.filename && (
        <div className="text-[10px] text-[var(--success)] mt-1 break-words">Saved · {out.filename}</div>
      )}
    </NodeShell>
  );
}
